<template>
  <div>
    <el-dialog
      title="新增套餐"
      :visible.sync="dialogVisible"
      :before-close="cancel">
        <el-form :model="form" label-width="250px" label-position="left">
            <el-form-item label="套餐类型">
                <el-radio-group v-model="form.type">
                    <el-radio label="ordinary">普通套餐</el-radio>
                    <el-radio label="advanced">高级套餐</el-radio>
                    <el-radio label="addition">加油包</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="国家/地区">
                <el-select v-model="form.province" filterable placeholder="请选择">
                    <el-option
                    v-for="item in countryList"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>             
            <el-form-item label="运营商">
                <el-select v-model="form.isp_addr" placeholder="请选择">
                    <el-option
                    v-for="item in ispList"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>              
            <el-form-item label="套餐名称">
                <el-input v-model='form.name'></el-input>
            </el-form-item>            
            <el-form-item label="套餐流量">
                <el-input v-model='form.flow'></el-input>
            </el-form-item>            
            <el-form-item label="套餐时长（天）" v-if='form.type=="ordinary"'>
                <el-input v-model='form.long'></el-input>
            </el-form-item>            
            <el-form-item label="官网套餐价格（元）">
                <el-input v-model='form.web_price'></el-input>
            </el-form-item>            
            <el-form-item label="PC端套餐价格（元）">
                <el-input v-model='form.pc_price'></el-input>
            </el-form-item>            
            <el-form-item label="android端套餐价格（元）">
                <el-input v-model='form.android_price'></el-input>
            </el-form-item>            
            <el-form-item label="原价（元）">
                <el-input v-model='form.pc_original'></el-input>
            </el-form-item>            
            <el-form-item label="是否显示标签">
                <el-radio-group v-model="form.is_tag">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>            
            <el-form-item label="标签名字">
                <el-input v-model='form.tag'></el-input>
            </el-form-item>            
            <el-form-item label="在线数单价（元）" v-if="form.type != 'addition'">
                <el-input v-model='form.online_price'></el-input>
            </el-form-item>       
             <el-form-item label="购买单个在线数赠送流量（GB）" v-if="form.type != 'addition'">
                <el-input v-model.number='form.free_flow'></el-input>
            </el-form-item>     
            <el-form-item label="备注">
                <el-input v-model='form.note'></el-input>
            </el-form-item>            
            <el-form-item label="状态">
                <el-radio-group v-model="form.is_published">
                    <el-radio :label="1">有效</el-radio>
                    <el-radio :label="0">失效</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { meal_add, isp_list } from "@/request/api.js";
export default {
    created(){
        this.getIspList()
    },
    props:{
        dialogVisible:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            form:{
                type:"ordinary"
            },
            countryList:[
                "美国","香港","安道尔","阿联酋","阿富汗","安提瓜和巴布达","安圭拉","阿尔巴尼亚","亚美尼亚","安哥拉",
                "南极洲","阿根廷","美属萨摩亚","奥地利","澳大利亚","阿鲁巴","奥兰群岛","阿塞拜疆","波黑","巴巴多斯",
                "孟加拉","比利时","布基纳法索","保加利亚","巴林","布隆迪","贝宁","圣巴泰勒米岛","百慕大","文莱",
                "玻利维亚","荷兰加勒比区","巴西","巴哈马","不丹","布韦岛","博茨瓦纳","白俄罗斯","伯利兹","加拿大",
                "科科斯群岛","中非","瑞士","智利","喀麦隆","哥伦比亚","哥斯达黎加","古巴","佛得角","圣诞岛",
                "塞浦路斯","捷克","德国","吉布提","丹麦","多米尼克","多米尼加","阿尔及利亚","厄瓜多尔","爱沙尼亚",
                "埃及","西撒哈拉","厄立特里亚","西班牙","芬兰","斐济群岛","密克罗尼西亚联邦","法罗群岛","法国","加蓬",
                "格林纳达","格鲁吉亚","法属圭亚那","加纳","直布罗陀","格陵兰","几内亚","瓜德罗普","赤道几内亚","希腊",
                "危地马拉","关岛","几内亚比绍","圭亚那","赫德岛和麦克唐纳群岛","洪都拉斯","克罗地亚","海地","匈牙利","印尼",
                "爱尔兰","以色列","马恩岛","印度","英属印度洋领地","伊拉克","伊朗","冰岛","意大利","泽西岛",
                "牙买加","约旦","日本","柬埔寨","基里巴斯","科摩罗","科威特","开曼群岛","黎巴嫩","列支敦士登",
                "斯里兰卡","利比里亚","莱索托","立陶宛","卢森堡","拉脱维亚","利比亚","摩洛哥","摩纳哥","摩尔多瓦",
                "黑山","法属圣马丁","马达加斯加","马绍尔群岛","马其顿","马里","缅甸","澳门","马提尼克","毛里塔尼亚",
                "蒙塞拉特岛","马耳他","马尔代夫","马拉维","墨西哥","马来西亚","纳米比亚","尼日尔","诺福克岛","尼日利亚",
                "尼加拉瓜","荷兰","挪威","尼泊尔","瑙鲁","阿曼","巴拿马","秘鲁","法属波利尼西亚","巴布亚新几内亚",
                "菲律宾","巴基斯坦","波兰","皮特凯恩群岛","波多黎各","巴勒斯坦","帕劳","巴拉圭","卡塔尔","留尼汪",
                "罗马尼亚","塞尔维亚","俄罗斯","卢旺达","所罗门群岛","塞舌尔","苏丹","瑞典","新加坡","斯洛文尼亚",
                "斯洛伐克","塞拉利昂","圣马力诺","塞内加尔","索马里","苏里南","南苏丹","圣多美和普林西比","萨尔瓦多","叙利亚",
                "斯威士兰","特克斯和凯科斯群岛","乍得","多哥","泰国","托克劳","东帝汶","突尼斯","汤加","土耳其",
                "图瓦卢","坦桑尼亚","乌克兰","乌干达","乌拉圭","梵蒂冈","委内瑞拉","英属维尔京群岛","美属维尔京群岛","越南",
                "瓦利斯和富图纳","萨摩亚","也门","马约特","南非","赞比亚","津巴布韦","刚果（布）","刚果（金）","莫桑比克",
                "根西岛","冈比亚","北马里亚纳群岛","埃塞俄比亚","新喀里多尼亚","瓦努阿图","法属南部领地","纽埃","美国本土外小岛屿","库克群岛",
                "英国","特立尼达和多巴哥","圣文森特和格林纳丁斯","台湾","新西兰","沙特阿拉伯","老挝","朝鲜 北朝鲜","韩国 南朝鲜","葡萄牙",
                "吉尔吉斯斯坦","哈萨克斯坦","塔吉克斯坦","土库曼斯坦","乌兹别克斯坦","圣基茨和尼维斯","圣皮埃尔和密克隆","圣赫勒拿","圣卢西亚","毛里求斯",
                "科特迪瓦","肯尼亚","蒙古国",
            ],
            ispList:[],
        }
    },
    methods:{
        cancel(){
            this.$emit('update:dialogVisible',false)
        },
        submit(){
            if(this.form.type=="ordinary" && !this.form.long){
                this.$message.error("套餐时长不能为空")
                return
            }
            if(this.form.type!='addition'){
                if(!this.form.online_price){
                    this.$message.error("普通套餐和高级套餐，在线数价格不能为空")
                    return
                }
            }
            console.log(typeof this.form.free_flow)
            meal_add(this.form).then(
                (res)=>{
                    if(res.status==0){
                        this.$message.success(res.detail)
                        this.$emit('freshData')
                        this.$emit('update:dialogVisible',false)
                    }else{
                        this.$messag.error(res.detail)
                    }
                }
            )
        },
        getIspList(){
            isp_list().then(
                (res)=>{
                    if(res.status==0){
                        this.$message.success(res.detail)
                        this.ispList = res.detail
                    }else{
                        this.$messag.error(res.detail)
                        this.ispList = []
                    }
                }
            )
        }
    }
}
</script>

<style lang = "less" scoped>
.el-input {
    width: 300px;
}
</style>